<template>
    <div class="flex rounded-full self-start cursor-pointer text-body-7 text-default-2" :class="styleClasses.like" @click="handleLike">
        <img v-if="!isLiked" src="@/assets/icons/like.svg" alt="Like" class="w-4 mr-1" />
        <img v-else src="@/assets/icons/liked.svg" alt="Like" class="w-4 mr-1" />
        <span>{{props.likesCount}}</span>
    </div>
</template>

<script setup>
import {computed} from "vue";
import {useLikes} from "@/composables/useLikes";
import {useAuth} from "@/stores/AuthStore";
import {storeToRefs} from "pinia";

const {createLike, deleteLike} = useLikes()
const {organization} = storeToRefs(useAuth());

const emit = defineEmits(['toggle-like'])

const props = defineProps({
    articleUid: {
        type: String,
        required: true,
    },
    likesCount: {
        type: Number,
        default: 0,
        required: true,
    },
    isLiked: {
        type: Boolean,
        default: false,
        required: true,
    },
    hasBackgroundStyle: {
        type: Boolean,
        default: true,
    }
})

const styleClasses = computed(() => {
    return {
        like: {
            'bg-semitone-color-3': props.isLiked && props.hasBackgroundStyle,
            'bg-interactive-9': !props.isLiked && props.hasBackgroundStyle,
            'px-2 py-1.5' : props.hasBackgroundStyle,
        }
    }
})

function handleLike() {
    if(props.isLiked) {
        deleteLike(organization.value.slug, props.articleUid)
    } else {
        createLike(organization.value.slug, props.articleUid)
    }

    emit('toggle-like')
}
</script>